import { Grid } from "@mui/material";
import { useContext, useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { PrintDiv, ToFormData } from "../../../hooks/Method";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";
import CustomerSect from "./CustomerSect";
import AdditionalDiscount from "./AdditionalDiscount";
import { action, controller, Server } from "../../../api/Server";
import ReceivePayment from "./PaymentReceived/ReceivePayment";
import PaymentType from "./PaymentReceived/PaymentType";
import Payments from "./PaymentReceived/Payments";
import { CartContext } from "../Pos";
import SubmitSale from "./SubmitSale";

const Checkout = (props) => {
  const {
    subTotal,
    cartItems,
    totalPay,
    setTotalPay,
    tax,
    setReceptData,
    handleClearCart,
    setAlert,
    setTax,
    setTaxPct,
  } = props;
  const { editSale } = useContext(CartContext);
  const { selStore, stores, settings, setPageTitle, authUser, setLoader } =
    useContext(AppContext);
  const { SellMdl } = Model();
  const { t } = useTranslation();
  const {
    values,
    errors,
    setErrors,
    handleInpChg,
    handleInpDate,
    setValues,
    handleInpCheck,
  } = UseForm(SellMdl);
  const receiveAmtRef = useRef();

  const [needToPayAmt, setNeedToPayAmt] = useState(totalPay || 0);
  const [store, setStore] = useState({});
  const [access, setAccess] = useState({});
  const [emailInv, setEmailInv] = useState(false);
  const [receiveAmt, setReceiveAmt] = useState("");

  useEffect(() => {
    if (authUser && authUser.featuresAccess && authUser.featuresAccess.pos)
      setAccess({ ...authUser.featuresAccess.pos });
    return () => {};
  }, [authUser]);

  // Get Selected or Default store details
  useEffect(() => {
    setPageTitle(t("checkout"));
    setStore(stores.find((j) => j.id === selStore));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  // Define default data.
  useEffect(() => {
    setValues((j) => ({
      ...j,
      id: editSale?.id || "",
      storeId: selStore,
      sellItems: cartItems,
      taxPct: store ? store.tax : 0,
      tax: tax,
      totalPay: totalPay,
      received: "",
      discount: "",
      subtotal: subTotal.toFixed(settings.decimal),

      userId: authUser.id,
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPay, store, editSale]);

  // =======** Calculate Total Amount to Pay **=======
  useEffect(() => {
    var _disAmt = parseFloat(values.disAmt || 0);
    var _dueAmt = parseFloat(values.dueAmt || 0);
    var _creditAmt = parseFloat(values.creditAmt || 0);
    var _received = parseFloat(values.received || 0);

    var _leftAmt = (
      totalPay -
      (_disAmt + _dueAmt + _creditAmt + _received)
    ).toFixed(settings.decimal);
    setNeedToPayAmt(parseFloat(_leftAmt));
    setReceiveAmt(Math.max(0, _leftAmt).toFixed(settings.decimal));

    setValues((j) => ({
      ...j,
      totalPay: (totalPay - (_disAmt + _dueAmt)).toFixed(settings.decimal),
      change: Math.abs(_leftAmt < 0 ? _leftAmt : 0),
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    totalPay,
    values.disAmt,
    values.dueAmt,
    values.creditAmt,
    values.received,
  ]);

  useEffect(() => {
    var _totalReceived = values.payments.reduce(
      (a, b) => a + parseFloat(b.amount),
      0
    );
    setValues((j) => ({
      ...j,
      received: parseFloat(_totalReceived.toFixed(settings.decimal)),
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.payments, values.cstmrId]);

  // Calculate Discount Amount
  useEffect(() => {
    if (values.discountType === 1) {
      setValues((j) => ({
        ...j,
        disAmt: (
          (parseFloat(totalPay) * parseFloat(values.discount || 0)) /
          100
        ).toFixed(settings.decimal),
      }));
    } else if (values.discountType === 2)
      setValues((j) => ({ ...j, disAmt: j.discount }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.discountType, values.discount]);

  const validateForm = () => {
    let temp = {};
    temp.received = needToPayAmt > 0 && 1 < needToPayAmt ? t("payMoreAmt") : "";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleEmailReceipt = (invoiceId) => {
    Server(controller.Sell + action.EmailInvoice).getById(invoiceId, (res) => {
      console.log("status: ", res.msg);
    });
  };

  const handleSubmit = () => {
    // **** Submit Action ****
    if (values.sellItems.length > 0 && validateForm()) {
      setLoader(true);
      const onComplete = (res) => {
        if (res && res.status === 200) {
          setReceptData(res.result);
          setTimeout(() => {
            PrintDiv("printSellRecept");
            // Email Sale Invoice
            if ((settings.emailInvoice === 2 || emailInv) && values.cstmrId) {
              handleEmailReceipt(res.result.id);
            }
            handleClearCart();
            setLoader(false);
          }, 1000);
        } else {
          setAlert({
            isOpen: true,
            type: "warning",
            title: t("warning"),
            subTitle: res.msg,
          });
          setLoader(false);
        }
      };

      // Differential Amount
      if (needToPayAmt < 1 && needToPayAmt > 0) values.diffAmt = needToPayAmt;

      // Submit data to the server.
      if (values.id > 0) {
        Server(controller.Sell + action.Put).put(
          ToFormData({
            ...values,
            sellItems: values.sellItems.map((j) =>
              j.itemType === 2 ? { ...j, productId: "" } : j
            ),
            lastUpdateDate: new Date().toISOString(),
          }),
          (res) => {
            localStorage.removeItem("sellId");
            onComplete(res);
          }
        );
      } else {
        Server(controller.Sell).post(
          ToFormData({
            ...values,
            sellItems: values.sellItems.map((j) =>
              j.itemType === 2 ? { ...j, productId: "" } : j
            ),
            sellDate: new Date().toISOString(),
          }),
          onComplete
        );
      }
    } else if (values.sellItems.length <= 0) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("warning"),
        subTitle: t("noItemInCart"),
      });
    } else if (needToPayAmt > 0) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("receivedAmount"),
        subTitle: t("youDidntReceivedEnoughAmount"),
      });
    }
  };

  return (
    <div className="pl-5 pr-2">
      <Grid container spacing={1.5}>
        <Grid item xs={12} md={access.isHaveGivingDiscountAccess ? 5 : 12}>
          <ReceivePayment
            {...{
              setReceiveAmt,
              receiveAmt,
              receiveAmtRef,
              values,
              handleInpCheck,
              needToPayAmt,
            }}
          />
        </Grid>
        {access.isHaveGivingDiscountAccess && (
          <Grid item xs={12} md={4}>
            <AdditionalDiscount
              {...{ values, setValues, handleInpChg, totalPay }}
            />
          </Grid>
        )}

        <Grid item xs={12} md={3}>
          <SubmitSale {...{ handleSubmit }} />
        </Grid>
        <Grid item xs={12} />

        {/* ---- Add or Submit Payment ---- */}
        <PaymentType
          {...{
            setValues,
            receiveAmt,
            receiveAmtRef,
          }}
        />

        {/* ---- Receive Payments ---- */}
        {values.payments.length > 0 && (
          <Grid item xs={12}>
            <Payments {...{ values, setValues, settings }} />
          </Grid>
        )}

        {/* ---- Select customer and credit sale ----  */}
        <Grid item xs={12} className="mt-20">
          <CustomerSect
            {...{
              values,
              setValues,
              errors,
              handleInpChg,
              handleInpDate,
              store,
              setTotalPay,
              setTax,
              setTaxPct,
              access,
              needToPayAmt,
              setNeedToPayAmt,
              setEmailInv,
              emailInv,
              handleClearCart,
              handleSubmit,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Input
            fullWidth
            placeholder={t("keepNoteIfYouWant")}
            name="note"
            value={values.note}
            onChange={handleInpChg}
            className="bg-white rmv-arrow br-8"
            variant="outlined"
            multiline
            rows={2}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default Checkout;
